import './FooterLoadingState.scss';

import React from 'react';

const FooterLoadingState = () => (
  <div className="footer-loading">
    <div className="container h-100">
      <div className="footer-content">
        <div className="skeleton-wrapper">
          <div className="skeleton-logo" />
        </div>

        <div className="nav-items">
          <div className="skeleton-wrapper">
            <div className="skeleton-nav-item" />
          </div>
          <div className="skeleton-wrapper">
            <div className="skeleton-nav-item" />
          </div>
          <div className="skeleton-wrapper">
            <div className="skeleton-nav-item" />
          </div>
        </div>

        <div className="nav-items">
          <div className="skeleton-wrapper">
            <div className="skeleton-nav-item" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default FooterLoadingState;
